import React, { FunctionComponent } from 'react';

import { LocationCellProps } from 'directory/listings/notification-modals/types';

import 'directory/listings/notification-modals/components/TableCells/TableCells.scss';

export const LocationCell: FunctionComponent<LocationCellProps> = ({ locationName }) => {
    return (
        <div className="location-cell">
            <div className="location-cell__name">{locationName}</div>
        </div>
    );
};
